module.exports = __webpack_public_path__ + "static/media/skeletonFire.240251f6.gif";